import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/business-operation-events/$eventInstanceId/",
)({});
